import api from './axios';

// Get all management members (with optional filters)
export const getManagementMembers = async (params = {}) => {
  const response = await api.get('/management', { params });
  return response.data;
};

// Get single management member
export const getManagementMember = async (id) => {
  const response = await api.get(`/management/${id}`);
  return response.data;
};

// Get management by category
export const getManagementByCategory = async (category) => {
  const response = await api.get(`/management/category/${category}`);
  return response.data;
};

// Get management statistics (admin)
export const getManagementStats = async () => {
  const response = await api.get('/management/admin/stats');
  return response.data;
};

// Create management member (admin - with image upload)
export const createManagementMember = async (formData) => {
  const response = await api.post('/management', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Update management member (admin - with optional image upload)
export const updateManagementMember = async (id, formData) => {
  const response = await api.patch(`/management/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

// Delete management member (admin)
export const deleteManagementMember = async (id) => {
  const response = await api.delete(`/management/${id}`);
  return response.data;
};

// Bulk delete management members (admin)
export const bulkDeleteManagementMembers = async (ids) => {
  const response = await api.delete('/management/bulk/delete', {
    data: { ids },
  });
  return response.data;
};

export default {
  getManagementMembers,
  getManagementMember,
  getManagementByCategory,
  getManagementStats,
  createManagementMember,
  updateManagementMember,
  deleteManagementMember,
  bulkDeleteManagementMembers,
};
